<template>
  <div class="content-box">
    <img class="cover" :src="shopDetails.coverPhoto.url">
    <p class="buy-box">
      <span class="buy-price">¥ {{ shopDetails.price }}</span>
      <a class="buy-btn" href="https://shop296494776.taobao.com/?spm=2013.1.0.0.4b0d3630xv1XsA" target="_blank">立即购买</a>
    </p>
    <main class="content">
      <h4 class="title">{{ shopDetails.title }}</h4>
      <p class="desc">{{ shopDetails.description }}</p>
      <img v-for="item in shopDetails.commodityPhotos" :src="item.url"/>
    </main>
    <section >
      <Title :title="'相关推荐'" />
      <article class="list-box">
        <Gallery v-for="item in shopDetails.similarCommodityList" :source="'Shop'" :gallery="item" :key="item.id" />
      </article>
    </section>
  </div>
</template>

<script>
  import Gallery from '@/components/GalleryM'
  import Title from '@/components/TitleM'
  import { mapGetters } from 'vuex'

  export default {
    components: { Gallery, Title},

    // 服务器端渲染，预加载专辑详情数据
    asyncData ({ store, route }) {
      return store.dispatch('getShopDetailById', route.params.id)
    },
    computed: {
      ...mapGetters({
        shopDetails: 'shopDetail'  // 处理商品详情数据
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .content-box {
    background-color: #FFF;
  }
  img {
    width: 100%;
  }
  .buy-box {
    padding: px2rem(10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .buy-price {
      color: #f39;
      font-size: px2rem(18px);
      font-weight: 600;
    }
    .buy-btn {
      display: inline-block;
      width: px2rem(80px);
      height: px2rem(30px);
      line-height: px2rem(30px);
      border-radius: 3px;
      background-color: #FF5196;
      color: #FFF;
      text-align: center;
    }
  }
  .content {
    padding: px2rem(10px);
    .desc {
      padding: px2rem(10px) 0;
      text-indent: px2rem(28px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ShopDetail.vue